import React, {useContext} from 'react';

const SettingsContext = React.createContext();

export const useSettingsContext = () => useContext(SettingsContext);
export default SettingsContext;
